import React from 'react';
import { X } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose} data-id="element-125">
      <div className="relative max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-[#FFFBF5] p-8 shadow-2xl ring-1 ring-[#E8DDD4] md:p-12" onClick={e => e.stopPropagation()} data-id="element-126">
        <button onClick={onClose} className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#FFF3E8] text-[#8B7D75] transition-colors hover:bg-[#E8DDD4] hover:text-[#2D2420]" aria-label="Cerrar" data-id="element-127">
          <X className="h-5 w-5" data-id="element-128" />
        </button>

        <h2 className="mb-8 font-serif text-3xl font-bold text-[#2D2420]" data-id="element-129">
          Términos y Condiciones
        </h2>

        <div className="space-y-6 text-[#2D2420] leading-relaxed" data-id="element-130">
          <section data-id="element-131">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-132">
              1. Información General
            </h3>
            <p data-id="element-133">
              "No Estoy Loca: Protocolo Culpa Cero" es un producto digital (PDF
              + workbook) creado con fines educativos e informativos. Al
              realizar tu compra, aceptas los siguientes términos y condiciones.
            </p>
          </section>

          <section data-id="element-134">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-135">
              2. Naturaleza del Producto
            </h3>
            <p data-id="element-136">
              Este protocolo NO es terapia psicológica, asesoría legal ni
              tratamiento médico. Es un recurso de autoayuda basado en técnicas
              de regulación emocional y psicoeducación. Si estás en crisis o en
              peligro físico, busca apoyo profesional inmediato.
            </p>
          </section>

          <section data-id="element-137">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-138">
              3. Entrega del Producto
            </h3>
            <p data-id="element-139">
              Una vez confirmado el pago, recibirás acceso inmediato al PDF
              descargable. El enlace de descarga se enviará al correo
              electrónico proporcionado durante la compra. Es tu responsabilidad
              proporcionar un correo válido.
            </p>
          </section>

          <section data-id="element-140">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-141">
              4. Política de Reembolso
            </h3>
            <p data-id="element-142">
              Ofrecemos una garantía de satisfacción de 30 días. Si el protocolo
              no cumple tus expectativas, puedes solicitar un reembolso completo
              dentro de los primeros 30 días posteriores a la compra, sin
              preguntas.
            </p>
          </section>

          <section data-id="element-143">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-144">
              5. Propiedad Intelectual
            </h3>
            <p data-id="element-145">
              Todo el contenido del protocolo está protegido por derechos de
              autor. Queda prohibida su reproducción, distribución o reventa
              total o parcial sin autorización expresa por escrito.
            </p>
          </section>

          <section data-id="element-146">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-147">
              6. Uso Personal
            </h3>
            <p data-id="element-148">
              La licencia de compra es para uso personal e individual. No está
              permitido compartir, redistribuir ni publicar el contenido en
              ninguna plataforma pública o privada.
            </p>
          </section>

          <section data-id="element-149">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-150">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-151">
              Los resultados pueden variar según cada persona. No garantizamos
              resultados específicos. El uso del protocolo es bajo tu propia
              responsabilidad y criterio.
            </p>
          </section>

          <section data-id="element-152">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-153">
              8. Privacidad
            </h3>
            <p data-id="element-154">
              Tu información personal (correo electrónico y datos de pago) se
              maneja de forma confidencial. No compartimos ni vendemos tus datos
              a terceros bajo ninguna circunstancia.
            </p>
          </section>

          <section data-id="element-155">
            <h3 className="mb-2 font-serif text-xl font-bold text-[#C4704B]" data-id="element-156">
              9. Contacto
            </h3>
            <p data-id="element-157">
              Para cualquier duda, solicitud de reembolso o aclaración, puedes
              escribirnos a nuestro correo de soporte. Responderemos en un plazo
              máximo de 48 horas hábiles.
            </p>
          </section>

          <div className="border-t border-[#E8DDD4] pt-6 text-center" data-id="element-158">
            <p className="text-sm text-[#8B7D75]" data-id="element-159">
              Última actualización: Febrero 2026
            </p>
            <button onClick={onClose} className="mt-4 rounded-full bg-[#C4704B] px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-[#A85A38]" data-id="element-160">
              Entendido, cerrar
            </button>
          </div>
        </div>
      </div>
    </div>;
}